<template>
    <search-box @search="search">
        <div slot="filters">
            <h6>{{capitalize(messages.dateRangeTitle)}}</h6>
            <div class="cform__group cform__group--no-margin">
                <div class="grid">
                    <div class="col-1-2">
                        <date-picker :placeholder="messages.from"
                                     type="datepicker" v-model="date_from"></date-picker>
                    </div>
                    <div class="col-1-2">
                        <date-picker :placeholder="messages.to"
                                     type="datepicker" v-model="date_to"></date-picker>
                    </div>
                </div>
            </div>
        </div>
    </search-box>
</template>

<script>
    import SearchBox from './search-box.vue';
    import DatePicker from './date-picker.vue';
    import { _T } from '../globals';

    export default {
        components: { SearchBox, DatePicker },
        data() {
            return {
                messages: {
                    dateRangeTitle: _T('Date'),
                    from: _T('from_to_from'),
                    to: _T('from_to_to')
                },
                date_from: '',
                date_to: ''
            };
        },
        methods: {
            capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            },
            search(query) {
                this.$emit('search', query, {
                    date: {
                        from: this.date_from,
                        to: this.date_to
                    }
                });
            }
        }
    };
</script>
